import { render, staticRenderFns } from "./saleContractCreation.vue?vue&type=template&id=82ff9810&scoped=true"
import script from "./saleContractCreation.vue?vue&type=script&lang=js"
export * from "./saleContractCreation.vue?vue&type=script&lang=js"
import style0 from "./saleContractCreation.vue?vue&type=style&index=0&id=82ff9810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ff9810",
  null
  
)

export default component.exports